module.exports = __webpack_public_path__ + "static/media/hipaa (active).adbee77f.svg";